import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { BoardCodeToDisplayNameEnum } from "../../../../../data-access/model/enum/room-detailed-card.enum";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { Subject, takeUntil } from "rxjs";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { ActivatedRoute, Router } from "@angular/router";
import { OfflineDialogComponent } from "src/app/libs/ui/components/offline-dialog/offline-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { isObject } from "lodash";
import { SharedService } from "src/app/libs/common/services/shared.service";

@Component({
  selector: "tic-room-detailed-card",
  templateUrl: "./room-detailed-card.component.html",
  styleUrls: ["./room-detailed-card.component.scss"],
})
export class RoomDetailedCardComponent {
  @Output() onSelect: EventEmitter<null> = new EventEmitter();
  @Output() roomView: EventEmitter<any> = new EventEmitter();
  @Output() mapView: EventEmitter<any> = new EventEmitter();

  @Input() room: any;
  @Input() currency: any;
  @Input() boards: any;
  @Input() index: number | undefined;
  @Input() showSelection: boolean = false;
  boardCodeToDisplayNameEnum = BoardCodeToDisplayNameEnum as any;
  roomOptions: any = {};
  data: any = {};
  roomRates: any = [];
  boardList: any = [];
  totalRoomPrice: number;
  totalAmount: number = 0;
  selectedRoomData: any;
  private destroy$ = new Subject();
  showPopup: boolean = false;
  previousHotelPrice: number;
  eventPrice: number = 0;
  flightPrice: number = 0;
  cartRoomPrice: number = 0;
  boardPrice: number = 0;

  constructor(private routerService: RouterService,private cdr: ChangeDetectorRef,private routes: Router,
    public facadeCheckout: CheckoutFacade, private router: Router, private route: ActivatedRoute,
     private dialog: MatDialog,
     private _sharedService:SharedService) {
    this.routerService
      .getUrlParams()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.data = res;
    });
  }
  ngOnInit(): void {
    this.facadeCheckout.room$.pipe(takeUntil(this.destroy$)).subscribe((room) => { 
      if( room && Object.keys(room).length != 0 ) {
        this.cartRoomPrice = this.getNumericRoomPrice(room);
        this.createBoardList(room);
      }
    });
    this.facadeCheckout.vm$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if(data && data.totalPrice){
        this.totalAmount = data.totalPrice;
      }
      if(data && data.hotelPrice){
        this.previousHotelPrice = data.hotelPrice;
      }
      if(data && data.eventPrice) {
        this.eventPrice = data.eventPrice;
      }
      if(data && data.flightPrice) {
        this.flightPrice = data.flightPrice;
      }
    });
    
  }

  private createBoardList(room: any) {
    this.roomRates = this.getUniqueItems(this.room?.rates, "boardName");
    this.boardList = this.boards.map((board: any) => {

      const matchingRate = this.roomRates.find((rate: any) => board.code === rate.boardCode);
      let price = null;
      let include = false;
      if (matchingRate) {
        price = matchingRate.actualPrice - this.cartRoomPrice;
      }
      if ( this.room.roomCode == room.roomCode && board.code == room.boardCode) {
        include = true;
        this.boardPrice = price;
        this.totalRoomPrice = room.price;
        this.selectedRoomData = {
          name: room.name,
          boardName: room.boardName,
          code: room.boardCode,
          price: room.price
        };
      }
      return {
        boardCode: board.code,
        boardName: board.description.content,
        include: include,
        disabled: !!matchingRate, 
        price: price,
        actualPrice: matchingRate?.actualPrice
      };
    })
    .sort((a: any, b: any) => {
      // Sort the array to have "RO" on top
      if (a.boardCode === 'RO') return -1;
      if (b.boardCode === 'RO') return 1;
      return 0;
    });
    if ( this.room.roomCode != room.roomCode ) {
      this.boardPrice = this.boardList[0].price;
    }
    this.cdr.detectChanges();
  }

  private getUniqueItems(items: any[], propertyName: string): any[] {
    const uniqueItems: any[] = [];
    if (items) {
      items.forEach((item) => {
        if (
          !uniqueItems.some(
            (uniqueItem) => uniqueItem[propertyName] === item[propertyName]
          )
        ) {
          uniqueItems.push(item);
        }
      });
    }

    return uniqueItems;
  }

  getNumericRoomPrice(room: any): number {
    const match = String(room?.price).match(/-?[\d,.]+/);
    return match ? parseFloat(match[0].replace(/,/g, '')) : 0;
  }

  onSelectedRoom(room: any): void {
    if ( !navigator.onLine ) {
      this.dialog.open(OfflineDialogComponent);
      return;
    }
    if(this.selectedRoomData){  

    let updatedPrice;
    // if(this.previousHotelPrice) {
    //   updatedPrice = (this.totalAmount - this.previousHotelPrice) + this.totalRoomPrice;
    // } else {
    //   updatedPrice = this.totalAmount + this.totalRoomPrice;
    // }
    updatedPrice = this.eventPrice + this.flightPrice + this.totalRoomPrice;
    this.facadeCheckout.setTotalPrice(updatedPrice);
    this.facadeCheckout.setRoom({name: room.apartmentDescription,
      boardName: this.selectedRoomData.boardName,
      boardCode: this.selectedRoomData.code,
      roomCode: this.room.roomCode,
      price: this.selectedRoomData.price});
      localStorage.setItem('selectedRoom',room.roomCode);    
    this.facadeCheckout.setHotelPrice(this.totalRoomPrice);
    const currentUrlTree = this.routes.parseUrl(this.routes.url);
    const currentQueryParams = currentUrlTree.queryParams;
    const base64Data = this.objectToBase64(this.selectedRoomData);
    this.routerService.navigateAndAddParamsToUrl(
      {
        ...currentQueryParams,
        roomData: base64Data
      },
      false,
      PagesRoute.TripSummary
    );
  }else{
    this._sharedService.Error('Select room board first!')
    }
  }

  objectToBase64(obj: any): string {
    const jsonStr = JSON.stringify(obj);
    return btoa(jsonStr);
  }

  onSelectedRoomDetail(id: string): void {
    this.roomView.emit(id);
  }
  checkCheckBoxvalue(event: any,index: number, additionalPrice: number,roomPrice: number, roomName: any, roomCode: any) {
    if(event.target.checked)
    {
      this.boardList.forEach((board: any, i: number) => {
        if (i !== index && board.disabled ) {
          board.include = false;
        }
      });
      this.totalRoomPrice = roomPrice;
      this.boardPrice = additionalPrice;
      this.selectedRoomData = {
        name: this.room.apartmentDescription,
        boardName: roomName,
        code: roomCode,
        price: this.totalRoomPrice
      };
    } else{
      this.boardList.forEach((board: any, i: number) => {
        if (i !== index && board.disabled ) {
          board.include = true;
        }
      });
    }
    
  }

  ViewMap(){
    this.mapView.emit();
  }
  
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
